window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Mixins ??= {};

AppointmentBooking.Wizard.Views.Mixins.RecoverableError = (superclass) =>
  (() => {
    const Cls = class extends superclass {
      constructor() {
        super(...arguments);
        this.initialize = this.initialize.bind(this);
        this.contextForRender = this.contextForRender.bind(this);
        this.hasRecoverableErrors = this.hasRecoverableErrors.bind(this);
        this.getRecoverableErrors = this.getRecoverableErrors.bind(this);
        this.getRecoverableErrorTypes = this.getRecoverableErrorTypes.bind(this);
      }

      // Default — subclasses override with an array, function, or string of
      // error types they can recover from. CoffeeScript's class-body
      // `recoverableErrorTypes: []` produced this prototype default; the
      // decaffeinated rewrite dropped it, which made `getRecoverableErrorTypes()`
      // throw for every step without an override (Welcome, Visit, SignIn,
      // Patient, VerifyId), breaking the wizard's first render silently
      // because `Wizard#_init` swallows render errors in a try/catch.

      initialize() {
        super.initialize(...arguments);

        return this.listenTo(this.model, "change:errors", this.render);
      }

      // RENDERING

      contextForRender() {
        const context = super.contextForRender(...arguments);
        context["recoverable_errors"] = this.getRecoverableErrors();

        return context;
      }

      // HELPER FUNCTIONS

      hasRecoverableErrors() {
        return this.getRecoverableErrors().length;
      }

      getRecoverableErrors() {
        return _.intersection(this.model.get("errors"), this.getRecoverableErrorTypes());
      }

      getRecoverableErrorTypes() {
        if (_.isFunction(this.recoverableErrorTypes)) {
          return this.recoverableErrorTypes();
        } else if (_.isArray(this.recoverableErrorTypes)) {
          return this.recoverableErrorTypes;
        } else if (_.isString(this.recoverableErrorTypes)) {
          return [this.recoverableErrorTypes];
        } else {
          throw `Unsupported value in \`recoverableErrorTypes\`: ${JSON.stringify(this.recoverableErrorTypes)}`;
        }
      }
    };
    Cls.prototype.recoverableErrorTypes = [];
    return Cls;
  })();
